'use strict';

let constants = {};

constants.cookie = create([
  ['GENERAL_EXPIRES', 1000 * 60 * 60 * 24 * 30],
  'SIDEBAR_MINIMIZED'
]);

function create(object, items) {
  if (arguments.length < 2) {
    items = object;
    object = {};
  }
  for (let item of items) {
    if (Array.isArray(item)) {
      object[item[0]] = item[1];
    } else {
      object[item] = item;
    }
  }
  return object;
}

module.exports = constants;




// WEBPACK FOOTER //
// ./helpers/constants.js